import { render, staticRenderFns } from "./waterResourcesCar.vue?vue&type=template&id=548bcd10&scoped=true&"
import script from "./waterResourcesCar.vue?vue&type=script&lang=js&"
export * from "./waterResourcesCar.vue?vue&type=script&lang=js&"
import style0 from "./waterResourcesCar.vue?vue&type=style&index=0&id=548bcd10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548bcd10",
  null
  
)

export default component.exports